import { c as _c } from "react/compiler-runtime";
import { IcoInfo16 } from '@onefootprint/icons';
import { Badge, Tag, Tooltip } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import isNull from 'lodash/isNull';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { FormattedName } from '../../../../../../../../onboarding-business-insight.types';
import { EMPTY_VALUE } from '../../../../../../constants';
type RowProps = {
  businessName: FormattedName;
  onOpen: (id: string) => void;
};
const Row = t0 => {
  const $ = _c(41);
  const {
    businessName: t1,
    onOpen
  } = t0;
  const {
    name,
    sources,
    sourceSOSFilingId,
    submitted,
    verified,
    kind
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "onboardings"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  const [isNameTruncated, setIsNameTruncated] = useState(false);
  const nameRef = useRef(null);
  let t3;
  let t4;
  if ($[1] !== name) {
    t3 = () => {
      const nameElement = nameRef.current;
      if (nameElement && name) {
        setIsNameTruncated(nameElement.offsetWidth < nameElement.scrollWidth);
      }
    };
    t4 = [name];
    $[1] = name;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] !== kind || $[5] !== t) {
    t5 = () => {
      if (kind === "dba") {
        return t(_temp);
      }
      if (kind === "legal") {
        return t(_temp2);
      }
      return EMPTY_VALUE;
    };
    $[4] = kind;
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const getKindText = t5;
  let t6;
  if ($[7] !== onOpen || $[8] !== sourceSOSFilingId) {
    t6 = () => {
      if (!sourceSOSFilingId) {
        return;
      }
      onOpen(sourceSOSFilingId);
    };
    $[7] = onOpen;
    $[8] = sourceSOSFilingId;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleClick = t6;
  const t7 = Boolean(sourceSOSFilingId);
  const t8 = !sourceSOSFilingId;
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = cx("flex gap-1 justify-start items-center w-full min-w-0 flex-shrink-1", {
      "cursor-pointer": t7,
      "cursor-default": t8
    });
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = isNameTruncated ? name : undefined;
  let t11;
  if ($[13] !== name || $[14] !== t10) {
    t11 = <p className="truncate text-body-2" ref={nameRef} title={t10}>{name}</p>;
    $[13] = name;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== sources || $[17] !== t) {
    t12 = sources && <Tooltip content={t(_temp3, {
      sources
    })}><IcoInfo16 /></Tooltip>;
    $[16] = sources;
    $[17] = t;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== submitted || $[20] !== t) {
    t13 = !isNull(submitted) && <Tag>{submitted ? t(_temp4) : t(_temp5)}</Tag>;
    $[19] = submitted;
    $[20] = t;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t || $[23] !== verified) {
    t14 = !isNull(verified) && <Badge variant={verified ? "success" : "error"}>{verified ? t(_temp6) : t(_temp7)}</Badge>;
    $[22] = t;
    $[23] = verified;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t13 || $[26] !== t14) {
    t15 = <div className="flex flex-shrink-0 gap-1 items-center ml-3">{t13}{t14}</div>;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== handleClick || $[29] !== t11 || $[30] !== t12 || $[31] !== t15 || $[32] !== t9) {
    t16 = <td><button className={t9} onClick={handleClick} type="button">{t11}{t12}{t15}</button></td>;
    $[28] = handleClick;
    $[29] = t11;
    $[30] = t12;
    $[31] = t15;
    $[32] = t9;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== getKindText) {
    t17 = getKindText();
    $[34] = getKindText;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t17) {
    t18 = <td>{t17}</td>;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t16 || $[39] !== t18) {
    t19 = <>{t16}{t18}</>;
    $[38] = t16;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  return t19;
};
export default Row;
function _temp($) {
  return $.businessDetails.name.table.dba;
}
function _temp2($_0) {
  return $_0.businessDetails.name.table.legal;
}
function _temp3($_1) {
  return $_1.businessDetails.name.table.source;
}
function _temp4($_2) {
  return $_2.businessShared.tags.submitted;
}
function _temp5($_3) {
  return $_3.businessShared.tags.notSubmitted;
}
function _temp6($_4) {
  return $_4.businessShared.tags.verified;
}
function _temp7($_5) {
  return $_5.businessShared.tags.notVerified;
}